import request from '@/http/axios'

// 获取用户登录信息
export function getUserInfo() {
  return request({
    url: `/v1/token/user-detail`,
    method: 'get',
  })
}

// 用户退出登录
export function logout(data) {
  return request({
    url: `/v1/token/logout`,
    method: 'post',
    data,
  })
}

// 获取术语类型分类
export function getTermType(data) {
  return request({
    url: `/v1/list_term_type`,
    method: 'post',
    data,
  })
}

// 获取文件上传token
export function getUploadToken(type) {
  return request({
    url: `/v1/file/token/${type}`,
    method: 'get',
  })
}

// 获取文件上传token new
export function getUploadTokenNew(data) {
  return request({
    url: `/v1/file/token`,
    method: 'post',
    data,
  })
}

// 上传文件
export function uploadFile(url, data) {
  return request({
    url: url,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  })
}

// 上传文件 new
export function uploadFileNew(url, headers, data, onUploadProgress) {
  return request(
    {
      url: url,
      method: 'put',
      headers,
      data,
      onUploadProgress,
    },
    {
      withCredentials: false,
    }
  )
}

// 新建术语提取
export function termExtract(data) {
  return request({
    url: '/v1/term_extract',
    method: 'post',
    data,
  })
}

// 查询术语提取结果
export function getTermExtract(params) {
  return request({
    url: `/v1/term_extract/${params}`,
    method: 'get',
  })
}

// 新建文档拆分
export function docSplit(data) {
  return request({
    url: '/v1/document_split',
    method: 'post',
    data,
  })
}

// 查询文档拆分结果
export function getDocSplit(params) {
  return request({
    url: `/v1/document_split/${params}`,
    method: 'get',
  })
}

// 意见反馈/工具需求 - 添加
//type TOOL_REQUIREMENTS 工具需求，FEEDBACK 意见反馈
export function feedback(data) {
  return request({
    url: '/v1/feedback',
    method: 'post',
    data,
  })
}

// 查询术语详情列表
export function getTermDetailList(data) {
  return request({
    url: '/v1/list_page_term_detail',
    method: 'post',
    data,
  })
}

// 更新术语译文
export function updateTermList(data) {
  return request({
    url: '/v1/update_term_translation',
    method: 'post',
    data,
  })
}

// 查询术语句子详情
export function termSentDetail(data) {
  return request({
    url: '/v1/list_term_sent_detail',
    method: 'post',
    data,
  })
}

// 导出术语
export function exportTerm(data) {
  return request({
    url: '/v1/export_excel',
    method: 'post',
    data,
  })
}

// 网文翻译接口
export function translateFunc(data) {
  return request({
    url: '/v1/mt_demo/get_novel_test',
    method: 'post',
    data,
  })
}

// 获取用户当前字符数
export function getUserRuns(data) {
  return request({
    url: '/v1/mt_demo/get_user_runes',
    method: 'post',
    data,
  })
}

// 新建文档合并
export function documentMerge(data) {
  return request({
    url: '/v1/document_merge',
    method: 'post',
    data,
  })
}

// 查询文档合并结果
export function getDocumentMerge(params) {
  return request({
    url: `/v1/document_merge/${params}`,
    method: 'get',
  })
}

// 获取语种结果
export function getLanguage(data) {
  return request({
    url: `/v1/language_recognition`,
    method: 'post',
    data,
  })
}

// 获取token
export function getToken(data) {
  return request({
    url: `/v1/token/ticket`,
    method: 'post',
    data,
  })
}

// 获取跳转术语语料平台 ticket
export function getTicket(data) {
  return request({
    url: `/v1/term-corpus/ticket`,
    method: 'post',
    data,
  })
}

// 获取语料对齐配置数据
export function getConfig() {
  return request({
    url: `/v1/corpus_align/config`,
    method: 'get',
  })
}

// 分页查询对齐数据
export function getCorpusAlignPage(params) {
  return request({
    url: `/v1/corpus_align`,
    method: 'get',
    params,
  })
}

// 新建语料对齐
export function corpusSaveOrUpdate(data) {
  return request({
    url: `/v1/corpus_align`,
    method: 'post',
    data,
  })
}

// 删除对齐文件
export function corpusAlignDeleteFilePair(id) {
  return request({
    url: `/v1/corpus_align/file/${id}`,
    method: 'delete',
  })
}

// 查询语料对齐详情
export function getDetail(id) {
  return request({
    url: `/v1/corpus_align/detail/${id}`,
    method: 'get',
  })
}

// 更新对齐信息
export function putDetail(data) {
  return request({
    url: `/v1/corpus_align`,
    method: 'put',
    data,
  })
}

// 获取术语提取记录列表
export function recordList(params) {
  return request({
    url: `/v1/list_page_term_extract`,
    method: 'get',
    params,
  })
}

// 查询邀请结果
export function getInviteRes(data) {
  return request({
    url: `/v1/get_invitation_result`,
    method: 'post',
    data,
  })
}

// 获取对齐文件下载地址
export function corpusAlignFileDownload(data) {
  return request({
    url: `/v1/corpus_align_file_download`,
    method: 'post',
    data,
  })
}

// 生成邀请key
export function createInviteKey(data) {
  return request({
    url: `/v1/generate_invite_key`,
    method: 'post',
    data,
  })
}

// 移除邀请
export function deleteInvite(data) {
  return request({
    url: `/v1/delete_invitation`,
    method: 'post',
    data,
  })
}

// 接受邀请
export function acceptInvite(params) {
  return request({
    url: `/v1/accept_invitation`,
    method: 'get',
    params,
  })
}

// 查询邀请结果 list
export function getResList(data) {
  return request({
    url: `/v1/list_page_invitation_result`,
    method: 'post',
    data,
  })
}

// 查询邀请术语详情
export function getInviteTermDetailList(data) {
  return request({
    url: `/v1/list_page_invite_term_detail`,
    method: 'post',
    data,
  })
}

// 获取语种列表
export function getLangList(params) {
  return request({
    url: `/v1/list_language_type`,
    method: 'get',
    params,
  })
}

// 获取语种字数转化比例系数
export function getCountCalculator(params) {
  return request({
    url: `/v1/list_language_conversion`,
    method: 'get',
    params,
  })
}

// 新增术语提取任务
export function newTermTask(data) {
  return request({
    url: `/v1/term_extract_group`,
    method: 'post',
    data,
  })
}

// 保存语料
export function saveRes(data) {
  return request({
    url: `/v1/smart/save_corpus_entry`,
    method: 'post',
    data,
  })
}

// 获取机翻结果
export function getMtRes(params) {
  return request({
    url: `/v1/smart/smart_mt`,
    method: 'get',
    params,
  })
}

// smart mt demo 获取我创建的语料库
export function getCorpusLib(params) {
  return request({
    url: `/v1/smart/get_corpus_libraries`,
    method: 'get',
    params,
  })
}

// 统计术语详情
export function getTermDetail(params) {
  return request({
    url: `/v1/stat_term_detail`,
    method: 'get',
    params,
  })
}

// 更新术语原文
export function updateTermName(data) {
  return request({
    url: `/v1/update_term_name`,
    method: 'POST',
    data,
  })
}

// 新增术语
export function createTermName(data) {
  return request({
    url: `/v1/create_term_detail`,
    method: 'POST',
    data,
  })
}

// 上传统计数据
export function uploadPageUseInfo(data) {
  return request({
    url: `/v1/tool_statistics_refresh`,
    method: 'post',
    data,
  })
}

// 文本语种识别
export function textLangRecognition(data) {
  return request({
    url: `/v1/text_language_recognition`,
    method: 'post',
    data,
  })
}

// 术语提取
export function gptTermExtract(data) {
  return request({
    url: `/v1/transn_gpt/term_extract`,
    method: 'post',
    data,
  })
}

// 文本润色
export function gptTextPolish(data) {
  return request({
    url: `/v1/transn_gpt/text_polish`,
    method: 'post',
    data,
  })
}

// 文本翻译
export function gptTextTranslate(data) {
  return request({
    url: `/v1/transn_gpt/text_translate`,
    method: 'post',
    data,
  })
}

// 翻译质检
export function gptTranslateQualityCheck(data) {
  return request({
    url: `/v1/transn_gpt/translate_quality_check`,
    method: 'post',
    data,
  })
}

// 添加到术语库
export function addToTermLibrary(data) {
  return request({
    url: `/v1/add_to_term_library`,
    method: 'post',
    data,
  })
}

// 修改删除状态
export function modifyRemove(data) {
  return request({
    url: `/v1/modify_remove`,
    method: 'post',
    data,
  })
}

// ListAllMyCreatedTermCorpus 我创建的术语语料库列表
export function getMyCreatedLibraries(params) {
  return request({
    url: `/v1/term_corpus/my_created_libraries`,
    method: 'get',
    params,
  })
}

// 添加语料到语料库
export function addAlignFileToLibrary(data) {
  return request({
    url: `/v1/add_align_file_to_library`,
    method: 'post',
    data,
  })
}

// 是否自动付费
export function autoPay(params) {
  return request({
    url: `/v1/auto_pay`,
    method: 'get',
    params,
  })
}

// 获取待支付信息
export function calculate(params) {
  return request({
    url: `/v1/calculate`,
    method: 'get',
    params,
  })
}

// 获取待支付订单信息-new
export function transactioInfo(params) {
  return request({
    url: `/v1/transaction_info`,
    method: 'get',
    params,
  })
}

// 支付&启动任务
export function startTask(data) {
  return request({
    url: `/v1/start_task`,
    method: 'post',
    data,
  })
}

// 退款
export function refund(data) {
  return request({
    url: `/v1/refund`,
    method: 'post',
    data,
  })
}

// 任务重试
export function retryTask(data) {
  return request({
    url: `/v1/retry_task`,
    method: 'post',
    data,
  })
}

// 删除任务
export function deleteTask(data) {
  return request({
    url: `/v1/delete`,
    method: 'post',
    data,
  })
}

// 创建支付订单
export function rechargeCreate(data) {
  return request({
    url: `/v1/recharge/create`,
    method: 'post',
    data,
  })
}

// 查询支付结果.
export function rechargeGet(params) {
  return request({
    url: `/v1/recharge/get`,
    method: 'get',
    params,
  })
}

// 获取充值包信息.
export function rechargeList(params) {
  return request({
    url: `/v1/recharge/list`,
    method: 'get',
    params,
  })
}

// 充值包优惠券列表.
export function getPackCoupon(params) {
  return request({
    url: `/v1/recharge/pack-coupon`,
    method: 'get',
    params,
  })
}

// 判断用户是否有会员权益.
export function hasMember(params) {
  return request({
    url: `/v1/recharge/has-member`,
    method: 'get',
    params,
  })
}

// 消息接口
export function countMessage(params) {
  return request({
    url: `/v1/token/count_message`,
    method: 'get',
    params,
  })
}

// 获取用户的最大会员等级.
export function levelPrivilege(params) {
  return request({
    url: `/v1/token/level-privilege`,
    method: 'get',
    params,
  })
}

// 获取域名定制
export function settingDetail(params) {
  return request({
    url: `/v1/domain/setting/detail`,
    method: 'get',
    params,
  })
}

// 企业设置
export function enterpriseSettingsApi(params) {
  return request({
    url: `/v1/enterprise/settings`,
    method: 'get',
    params,
  })
}

// 我加入的企业列表
export function enterpriseList(params) {
  return request({
    url: `/v1/enterprise/join`,
    method: 'get',
    params,
  })
}

// 切换企业.
export function switchEnterprise(data) {
  return request({
    url: `/v1/enterprise/switch`,
    method: 'post',
    data,
  })
}

// 语种列表
export function getLanguageList(params) {
  return request({
    url: `/v1/common/language`,
    method: 'get',
    params,
  })
}

// 获取算法支持的语种列表
export function getAlgorithmSupportedLanguages() {
  return request({
    url: `/v1/common/dictionary/iollab_term_algorithm_lang`,
    method: 'get',
  })
}

//获取最近使用的语种
export function getLatestLanguage(params) {
  return request({
    url: '/v1/translator/get_latest_language',
    method: 'get',
    params,
  })
}

//设置最近使用的语种
export function setLatestLanguage(data) {
  return request({
    url: '/v1/translator/set_latest_language',
    method: 'post',
    data,
  })
}

//创建PDF稿件脱敏任务
export function postPdfRedact(data) {
  return request({
    url: '/v1/pdf/redact',
    method: 'post',
    data,
  })
}

//获取PDF稿件脱敏结果
export function getRedactResult(params) {
  return request({
    url: '/v1/pdf/redact/result',
    method: 'get',
    params,
  })
}
